module.exports = __webpack_public_path__ + "img/icon-stock-where.ed13c838.png";